import React, {Component} from 'react';
import {Button} from "antd"
import {uuid} from "../../../../utils";
import $ from "jquery";
import ReactDOM from "react-dom";
import SyncModal from "../../../components/syncModal/syncModal";

export default function viewRecord({component, record, field, modalTitle, condition}) {
    return {
        name: modalTitle, condition: condition, onOk: () => {
            let id = `a${uuid()}`;
            $(document.body).append(`<div id='${id}'></div>`);
            let syncModal = null;
            let cancel = () => {
                syncModal.destroy();
                $(`#${id}`).remove();
            };
            ReactDOM.render(<SyncModal ref={ref => syncModal = ref}/>, document.getElementById(id));
            syncModal.confirm({
                title: modalTitle,
                width: 400,
                content: record[field],
                footer: [<Button type={"primary"} onClick={() => cancel()}>确定</Button>],
                onCancel: () => {
                    syncModal.destroy();
                    $(`#${id}`).remove();
                },
            })
        }
    };
}